'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  backgroundColor: 'rgba(0,0,0,0.9)',
  borderRadius: _reactackleCore.radiusDefault,
  paddingY: _reactackleCore.halfBaseModule,
  paddingX: _reactackleCore.baseModule,
  minWidth: 120,
  maxWidth: '100vw',
  fontSize: _reactackleCore.fontSizeXsmall,
  lineHeight: 1.3,
  fontColor: _reactackleCore.colorWhite,
  zIndex: _reactackleCore.zIndexTooltip,
  tooltipRefererSpacing: _reactackleCore.baseModule
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip/dist/styles/theme.js
// module id = 883
// module chunks = 0